import React from "react";
import { kblTeamLogo } from "../SonicBoomSchedule";

const ScheduleBox = ({ data }) => {
  let victory = "draw";
  let ktVictory = "";

  if (data.logoH === "kt" && data.scoreH > data.scoreA) {
    victory = "win";
    ktVictory = "winH";
  } else if (data.logoH === "kt" && data.scoreH < data.scoreA) {
    victory = "lose";
  } else if (data.logoA === "kt" && data.scoreH > data.scoreA) {
    victory = "lose";
  } else if (data.logoA === "kt" && data.scoreH < data.scoreA) {
    victory = "win";
    ktVictory = "winA";
  } else {
    victory = "draw";
  }

  const formatDate = (dateString) => {
    const year = parseInt(dateString.substring(0, 4));
    const month = parseInt(dateString.substring(4, 6));
    const day = parseInt(dateString.substring(6, 8));
    const date = new Date(year, month - 1, day);
    const options = { weekday: "short" };
    const weekday = date.toLocaleDateString("ko-KR", options);
    return `${day}(${weekday})`;
  };

  const formatTime = (timeString) => {
    const hours = parseInt(timeString.substring(0, 2));
    const minutes = timeString.substring(2, 4);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    return date.toLocaleTimeString("ko-KR", { hour: '2-digit', minute: '2-digit', hour12: true });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "295px",
        // maxWidth: "295px",
        height: "142px",
        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        borderRadius: "24px",
        padding: "12px 20px",
        backgroundColor: "white",
        margin: "10px 0px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontSize: "13px", fontWeight: "bold", color: "#35383e" }}>
          {formatDate(data.gameDate)} {formatTime(data.gameStart)}
        </div>
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center" }}>
          <div style={{ fontSize: "12px", color: "#35383e", marginRight: "3px" }}>{data.stadiumnameF}</div>
          {data.isStarted === 0 ? (
            <div
              style={{
                fontSize: "11px",
                fontWeight: "bold",
                color: "red",
                backgroundColor: "#eceef2",
                borderRadius: "10px",
                lineHeight:'13px',
                padding: "3px 7px",
              }}
            >
              경기예정
            </div>
          ) : data.isEnded === 1 ? (
            <div
              style={{
                fontSize: "11px",
                fontWeight: "bold",
                color: "#35383e",
                backgroundColor: "#eceef2",
                borderRadius: "10px",
                lineHeight:'13px',
                padding: "3px 7px",
              }}
            >
              경기종료
            </div>
          ) : data.isStarted === 1 && data.isEnded === 0 ? (
            <div
              style={{
                fontSize: "11px",
                fontWeight: "bold",
                color: "white",
                backgroundColor: "red",
                borderRadius: "10px",
                lineHeight:'13px',
                padding: "3px 7px",
              }}
            >
              경기중
            </div>
          ) : (
            <div
              style={{
                fontSize: "11px",
                fontWeight: "bold",
                color: "white",
                backgroundColor: "#abadb2",
                borderRadius: "10px",
                lineHeight:'13px',
                padding: "3px 7px",
              }}
            >
              경기취소
            </div>
          )}
        </div>
      </div>
      <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold", color: "#35383e", margin: "28px 0px 8px 0px" }}>
        KBL {data.seasonCategoryName}
      </div>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: data.isStarted === 0 ? "space-evenly" : "space-around", alignItems: "center" }}>
        <div style={{ textAlign: "center" }}>
          <img src={kblTeamLogo[data.logoH]} alt={data.logoH} style={{ width: "64px", height: "64px" }} />
        </div>
        {data.isStarted !== 0 &&
        <div
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: ktVictory === "winH" ? "bold" : "normal",
            color: ktVictory === "winH" ? "#ea0101" : "#35383e",
            textShadow: ktVictory === "winH" ? "2px 2px 4px #fbe8e8" : "none",
          }}
        >
          {data.scoreH}
        </div>
        }
        {data.isStarted === 0 ? (
          <img
            src={require("../../../assets/img/kbl/img_game_vs_color.png")}
            alt="vs"
            style={{ width: "40px", height: "25px" }}
          />
        ) : (
          <div style={{fontSize: "13px", textAlign: "center", color: victory === "win" ? "#ea0101" : victory === "lose" ? "#717378" : "#abadb2", fontWeight: "bold" }}>
            {victory === "win" ? "승리" : victory === "lose" ? "패배" : "무승부"}
          </div>
        )}
        {data.isStarted !== 0 &&
        <div
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: ktVictory === "winA" ? "bold" : "normal",
            color: ktVictory === "winA" ? "#ea0101" : "#35383e",
            textShadow: ktVictory === "winA" ? "2px 2px 4px #fbe8e8" : "none"
          }}
        >
          {data.scoreA}
        </div>
        }
        <div style={{ textAlign: "center" }}>
          <img src={kblTeamLogo[data.logoA]} alt={data.logoA} style={{ width: "64px", height: "64px" }} />
        </div>
      </div>
    </div>
  );
};
export default ScheduleBox;
